function handlePrice() {
  const lineItem = document.querySelectorAll(".mu-cart-item");
   fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    lineItem.forEach(item => {
      const idItem = item.getAttribute("data-variant-id");
      const cartItem = cart.items.find(i => i.id == idItem);
      if (cartItem) {
        const cartKey = cartItem.key;
        const price = item.querySelector(".mu-item-price");
        price.setAttribute("bss-b2b-cart-item-key", cartKey);
        price.setAttribute("bss-b2b-final-line-price", "");
      }
    });
    document
    .querySelector(".mu-subtotal [data-value]")
    .setAttribute("bss-b2b-cart-total-price", "true");
    setTimeout(() => {
      BSS_B2B.observer.cartSubject.notifyObserver("CartUpdate", "CartMutate");
    }, 500)
  })
  .catch(err => console.error('❌', err));
}

function handle() {
  const target = document.querySelector(".mp-checkout-btn-mode");
  if (target) {
    const prev = target.previousElementSibling;

    const isAlreadyInserted =
      prev &&
      prev.tagName.toLowerCase() === "button" &&
      prev.classList.contains("bss-custom");

    if (!isAlreadyInserted) {
      target.insertAdjacentHTML(
        "beforebegin",
        `
        <button class="bss-custom mu-custom-btn mu-w-full mu-py-3 mu-mb-2 mu-checkout-btn mu-flex mu-items-center mu-justify-center mu-rounded" style="
        background-color: rgb(0, 0, 0); 
        border-radius: 5px; 
        border: 1px solid rgb(0, 0, 0);
        color: rgb(255, 255, 255); 
        font-size: 13px; 
        font-weight: 600; 
        text-align: center;
        ">
          Checkout with protection
        </button>
      `
      );
      target.style.display = "none";
    }
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
}

function addCustomCheckoutClickHandler() {
  const button = document.querySelector(".bss-custom");
  if (button) {
    button.addEventListener(
      "click",
      () => {
        button.style.display = "none";
        setTimeout(() => {
          button.style.display = "";
        }, 2200);
      },
      true
    );
  }
}

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (
          item.target.classList.contains("mu-item-price") ||
          item.target.id === "mu-checkout-container"
        ) {
          handlePrice();
          handle();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(addCustomCheckoutClickHandler, 2000);
  });
}
